// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3SIiY","title":"Images45_title__tmqj-","images":"Images45_images__1yeVp"};